import { List } from 'react-content-loader';
const LoadingProjects = () => {
  return <List width={800} />;
};

export default LoadingProjects;
